import React, { Component } from 'react'
import { FormInput, SearchableList, Modal } from '../../components'
import { connect } from 'react-redux'
import { back } from '../../actions/nav-actions'
import { getProjectMembers, sendProjectInvite } from '../../api';
import { notify, testRegex } from '../../utils';

class Members extends Component {
    state = {
        email: '',
        members: []
    }
    componentDidMount() {
        let params = this.props.match.params || {};
        getProjectMembers(
            this.props.user.token,
            params.organization,
            params.code
        )
            .then((members) => this.setState({ members }))
            .catch((err) => notify('Error', err.message, 'error'))
    }
    addNewUser() {
        let params = this.props.match.params || {};
        let { email } = this.state;
        if (email.length === 0) return;
        sendProjectInvite(
            this.props.user.token,
            params.organization,
            params.code,
            {
                emails: [email]
            }
        )
            .then((invites) => {
                let newMembers = this.state.members.filter(i => {
                    let result = invites.filter(invite => invite.to === i.email)[0];
                    return !result;
                });
                this.setState({ email: '', members: invites.map(invite => ({ email: invite.to, accepted: invite.sent })).concat(newMembers) })
            })
            .catch(err => notify('Error', err.message, 'error'))
    }
    render() {
        return (
            <Modal
                title="Members"
                onClose={this.props.back}
                hideActions={true}
                visible={true}>
                <SearchableList
                    hideTitle={true}
                    formula={(text) => (item) => testRegex(item.email, text || '')}
                    empty_message="Don't find the searched member mail? Send an invitation on their mailbox"
                    options={this.state.members} />
                <FormInput
                    value={this.state.email}
                    onChange={(email) => this.setState({ email })}
                    placeholder="Type your new user email to add" />
                <div className="text-center">
                    <button onClick={this.addNewUser.bind(this)} className="btn btn-info">ADD USER</button>
                </div>
            </Modal>
        )
    }
}

const mapStateToProps = state => ({
    user: state.authReducer.user
});

const mapDispatchToProps = dispatch => ({
    back() {
        dispatch(back());
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(Members);


// WEBPACK FOOTER //
// ./src/routers/Projects/Members.js